import _ from 'lodash'
import * as R from 'ramda'

import {
  REMOVE_AUTOTASK_CREDENTIAL,
  REMOVE_CONNECTWISE_CREDENTIAL,
  REMOVE_ZENDESK_SYNC_SUCCESS,
  SET_AUTOTASK_AUTHENTICATION_SETTING,
  SET_CONNECTWISE_AUTHENTICATION_SETTING,
  SET_ZENDESK_AUTHENTICATION_SETTING,
  SET_ZENDESK_END_USER_CREDENTIAL,
} from 'actions'

const initialState = {
  zendesk: {
    authentication: {
      isActive: false,
    },
  },
  connectwise: {
    authentication: {},
  },
  autotask: {},
}

const integrationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ZENDESK_AUTHENTICATION_SETTING: {
      const a = action.settings
      return _.merge({}, state, {
        zendesk: {
          authentication: {
            email: a.zendesk_api_email,
            subdomain: a.zendesk_api_subdomain,
            token: a.zendesk_api_token,
            isActive: a.zendesk_api_is_active,
          },
        },
      })
    }
    case SET_CONNECTWISE_AUTHENTICATION_SETTING: {
      const a = action.settings
      return _.merge({}, state, {
        connectwise: {
          authentication: {
            url: a.connectwise_url,
            companyId: a.connectwise_company_id,
            publicKey: a.public_api_key,
            privateKey: a.private_api_key,
            isActive: a.is_active,
          },
        },
      })
    }
    case SET_AUTOTASK_AUTHENTICATION_SETTING: {
      return R.mergeDeepRight(state, {
        autotask: {
          [action.surveyToken]: {
            authentication: {
              username: action.settings.username,
              password: action.settings.password,
            },
          },
        },
      })
    }
    case REMOVE_AUTOTASK_CREDENTIAL: {
      return R.dissocPath(['autotask', action.surveyToken], state)
    }
    case REMOVE_CONNECTWISE_CREDENTIAL: {
      return R.merge(state, { connectwise: { authentication: {} } })
    }
    case REMOVE_ZENDESK_SYNC_SUCCESS: {
      return _.merge({}, state, {
        zendesk: {
          authentication: {
            isActive: false,
          },
        },
      })
    }
    case SET_ZENDESK_END_USER_CREDENTIAL: {
      const {
        end_user_id: id,
        end_user_email: email,
        end_user_password: password,
      } = action.credential
      return R.mergeDeepRight(state, {
        zendesk: {
          endUser: {
            id,
            email,
            password,
          },
        },
      })
    }
    default:
      return state
  }
}

export default integrationsReducer

export const getIsZendeskIntegrationActive = (state) => state.zendesk.authentication.isActive

export const getIsConnectwiseIntegrationActive = (state) =>
  !R.isEmpty(state.connectwise.authentication)

export const getAutotaskCredential = (state, surveyToken) =>
  R.pathOr({}, ['autotask', surveyToken, 'authentication'], state)

export const getIsAutotaskIntegrationActive = (state, surveyToken) =>
  !R.isEmpty(R.pathOr({}, ['autotask', surveyToken, 'authentication'], state))



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/reducers/data/integrations.js